var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "questionerVideo",
    staticClass: "questionerVideo",
    class: {
      isFullScreen: _vm.showFullScreen,
      notShowFootBar: !_vm.State.showFootBar
    }
  }, [_vm.State.batchMoveParticipate && _vm.questionerInfo.rtilCode > 0 && _vm.questionerInfo.rtilCode != _vm.userInfo.rtilCode ? _c('div', {
    staticClass: "checkBox"
  }, [_c('el-checkbox', {
    on: {
      "change": val => {
        _vm.moveParty(val, _vm.questionerInfo.rtilCode);
      }
    },
    model: {
      value: _vm.movePips[_vm.questionerInfo.rtilCode],
      callback: function ($$v) {
        _vm.$set(_vm.movePips, _vm.questionerInfo.rtilCode, $$v);
      },
      expression: "movePips[questionerInfo.rtilCode]"
    }
  })], 1) : _vm._e(), _c('NewAttendUser', {
    key: _vm.questionerInfo.rtilCode,
    ref: "questVideo",
    attrs: {
      "anywherePopShow": _vm.anywherePopShow,
      "title": _vm.questionerInfo.rtilCode ? _vm.questionerInfo.rtilCode + '' : '',
      "nickName": _vm.questionerInfo.nickName,
      "tagName": _vm.tagNameInfo[_vm.questionerInfo.rtilCode],
      "organization": _vm.questionerInfo.organization,
      "singChannel": _vm.stream,
      "userInfo": _vm.userInfo,
      "controlMute": _vm.hearVoice,
      "isAudioLevel": _vm.isAudioLevel,
      "rtc": _vm.rtc,
      "volume": _vm.volume,
      "degreeHost": _vm.degreeHost,
      "notShowEarphone": _vm.judgeEarphone,
      "showTitle": !_vm.questionerInfo.rtilCode ? false : true,
      "muteVideo": !_vm.State.cameraStatus[_vm.questionerInfo.rtilCode],
      "muteAudio": !_vm.State.micStatus[_vm.questionerInfo.rtilCode],
      "asRoleList": ['setQuestionSpeaker', 'setQuestioner'],
      "currentRole": "setQuestioner",
      "operateList": _vm.operateList,
      "liveInfo": _vm.liveInfo
    },
    on: {
      "callback": _vm.attendCallback
    },
    scopedSlots: _vm._u([_vm.questionerInfo.rtilCode ? {
      key: "videoBottom",
      fn: function () {
        return [_c('LiveSourceSelect', {
          ref: `liveSource${_vm.stream.id}`,
          attrs: {
            "allRList": _vm.allRList,
            "partyCode": _vm.userInfo.realPartyCode,
            "nickName": _vm.questionerInfo.nickName,
            "useNewUi": true,
            "rtilCode": _vm.stream.id,
            "memberId": _vm.stream.tid,
            "liveInfo": _vm.liveInfo
          },
          on: {
            "callback": _vm.callbackByLiveSource
          }
        })];
      },
      proxy: true
    } : null], null, true)
  }, [!_vm.questionerInfo.rtilCode ? _c('img', {
    staticClass: "tvuLogo",
    attrs: {
      "src": _vm.logoGray
    }
  }) : _vm._e()]), _vm.index ? _c('div', {
    staticClass: "indexBox"
  }, [_vm._v(" " + _vm._s(_vm.index) + " ")]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };